class DetailsDropdown extends HTMLElement {
    constructor() {
        super();

        this.mainDetails = this.querySelector('details');
        
        const clickAwayHandler = this.handleClickAway.bind(this);

        this.mainDetails.addEventListener('toggle', () => {
            if (this.mainDetails.open) {
                document.body.addEventListener('click', clickAwayHandler);
            } else {
                document.body.removeEventListener('click', clickAwayHandler);
            }
        })
    }

    handleClickAway(event) {
        if (!(this.contains(event.target))) {
            this.mainDetails.open = false;
        }
    }

    // handleClickAway(event) {
    //     const detailsElement = this.querySelector("details");
    //     const summaryElement = this.querySelector("summary");
    //     if (detailsElement && !detailsElement.contains(event.target)){
    //         this.mainDetails.open = false;
    //         detailsElement.removeAttribute("open");
    //     }
    // }
}

customElements.define('details-dropdown', DetailsDropdown);